/**
 * Types of filters used by the lead table.
 * @readonly
 * @enum {symbol}
 * @property {symbol} LIST Represents filters that accept an array of values
 * @property {symbol} RANGE Represents filters that accept a start and end value.
 */
const leadFilterTypes = Object.freeze({
    LIST: Symbol('LIST'),
    RANGE: Symbol('RANGE'),
})

export {leadFilterTypes}